import { OrderProfanityCheckStatus } from "@/types/order"
import axios from "./orderInstance"
import { toast } from "react-toastify"
export default async (orderId: string, lineItemsReq: {}) => {
  const payload = {
    operation: "set_profanity_check_status",
    values: lineItemsReq
  };

  try {
    const response: any = await axios.patch(`/orders/${orderId}/line-items`, payload);
    toast.success('Order changed successfully');
    return response.data
  } catch (error) {
    return null
  }
}
